import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5fa9a783&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=5fa9a783&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9a783",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fa9a783')) {
      api.createRecord('5fa9a783', component.options)
    } else {
      api.reload('5fa9a783', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=5fa9a783&scoped=true", function () {
      api.rerender('5fa9a783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/complaintreporting/online/detail.vue"
export default component.exports